import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=4157ad53&scoped=true&isComponent&outputPath=components%2Findex15b94fca%2Findex"
import script from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex15b94fca%2Findex"
export * from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex15b94fca%2Findex"
import style0 from "./index.mpx?vue&type=style&index=0&id=4157ad53&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m15b94fca%22%7D&isComponent&outputPath=components%2Findex15b94fca%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157ad53",
  null
  
)

export default component.exports